export default __webpack_public_path__ + "static/media/project-logo.162a1068.svg";